import { TreatmentType } from './treatmentType';
import { TreatmentSubType } from './treatmentSubType';
import { Patient } from './patient';
import { Member } from './member.model';
import { TreatmentPrintSetting } from './treatmentPrintSetting';
import { Tightness } from './tightness';
import { Scanner } from './scanner';
import { ArchType } from './arch-type';
import { TreatmentGuide } from './treatment-guide.model';
import { TreatmentTeethNote } from './treatment-teeth-note.model';
import { TreatmentInfoSections } from './treatment-info.model';
import { TreatmentFiles } from './treatment-file.model';
import { TreatmentDeliveryStatus } from './treatment-deliver-progress.model';
import { TreatmentRemovableDenture } from './removable-denture.model';
import { TreatmentStatus } from './treatment-status.model';
import { TreatmentReturnStatus } from './treatmentReturnRequest';
import { DentalNotation } from './dental-notation';
import { FabricationMethod } from './fabrication-method';
import { VeneerType } from './veneer-type';
import { TreatmentRevisionDetail } from './treatment-revision.model';
import { TreatmentImplant } from './treatment-implant';
import { RegionId } from './region-id.enum';
import { TreatmentClearAligner } from './treatment-clear-aligner.model';
import { TreatmentTag } from './tag';
import { StripeProductType } from './stripe-product-type';

export interface TreatmentDetail {
    removableDenture?: TreatmentRemovableDenture | null;
    patientFiles?: TreatmentFiles | null;
    treatmentPlan?: string | null;
    additionalComments?: string | null;
    annotation?: string | null;
    id: string;
    treatmentType: TreatmentType;
    treatmentSubType: TreatmentSubType;
    modifiedDate?: string | null;
    createdDate: string;
    createdBy: string;
    officeName: string;
    patient?: Patient;
    designerId?: string;
    designer?: Member | null;
    author?: Member;
    treatmentPrintSettings?: TreatmentPrintSetting[] | null;
    tightness?: Tightness | null;
    buccalCoverage?: string | null;
    scanner?: Scanner | null;
    archType: ArchType;
    treatmentGuide?: TreatmentGuide;
    treatmentTeethNotes?: TreatmentTeethNote[] | null;
    info?: TreatmentInfoSections | null;
    deliveryStatus: TreatmentDeliveryStatus;
    hasDelivered: boolean;
    isDelivering: boolean;
    status?: TreatmentStatus | null;
    hasDone: boolean;
    isPrintable: boolean;
    organizationId?: string | null;
    organization?: string | null;
    treatmentReturnStatus?: TreatmentReturnStatus | null;
    dentalNotation?: DentalNotation | null;
    fabricationMethod: FabricationMethod;
    veneerType?: VeneerType | null;
    activeRevision?: TreatmentRevisionDetail | null;
    activeRevisionId?: string | null;
    hasDoctorAdditionalMessage?: boolean;
    implant?: TreatmentImplant | null;
    fromAi?: boolean | null;
    originTreatmentId: string | null;
    upgradeFromTreatmentId: string | null;
    regionId?: RegionId | null;
    tinyId?: string | null;
    clearAligner?: TreatmentClearAligner | null;
    treatmentTags?: TreatmentTag[] | null;
    locale?: string | null;
    subscribedProductType?: StripeProductType | null;
    orderNumberPerTreatmentType?: number | null;
    isVipOffice?: boolean | null;
    officeId?: string | null;
}
